import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RentLoss } from '../../model/rent-loss';
import { Company } from '../../../rent/model/company';

@Injectable()
export class RentLossService extends DataService<RentLoss> {
  private readonly _default_FilterFields: string[] = ['year', 'month', 'companyId'];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, RentLoss, progressBar, 'rent-loss');
  }

  createRentLoss(year: number, month: number, companyId: string): Observable<any> {
    this.progressBar.start();
    return this.client.post(this.endpoint + '/create', { year: year, month: month, companyId: companyId }).pipe(
      tap(() => {
        this.notification.showSuccess();
      }),
      catchError(error => {
        this.notification.showError(error);
        throw error;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  exportFiltered(filter: any, includedIds: string[], excludedIds: string[], affectedItemsCount: number): Observable<File> {
    return super.exportDataItemsFiltered(filter, includedIds, excludedIds, affectedItemsCount, 'Hyresbortfall.xlsx', true);
  }

  getFilterDefinition(): Observable<{
    year: number;
    month: number;
    companyId: string;
    showVoided: boolean;
    companies: Company[];
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => {
          return {
            companyId: res.companyId ? res.companyId : '',
            showVoided: res.showVoided,
            companies: Array.isArray(res.companies) ? res.companies.map(x => Object.assign(new Company(), x)) : [],
            year: res.year,
            month: res.month,
            selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._default_FilterFields,
            defaultFields: this._default_FilterFields,
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }
}
